import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from "antd";
import BreadCrumb from "../../../../layout/BreadCrumb";
import {
  setRefetch,
  setRefetchKey,
} from "../../../../features/global/globalSlice";
import { useSearchParams } from "react-router-dom";
import ServicePerfList from "./service-perfomance/ServicePerfList";
import { fetchData } from "../../../../features/fetch/fetchSlice";

function AsalIndicatorsList() {
  const dispatch = useDispatch();

  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") || "1";
  const { refetchKey } = useSelector((state) => state.global);

  const [active, setactive] = useState(initialTab);

  const { iwuaObj } = useSelector((state) => state.obj);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["asalSchemes"],
  }));
  async function refetching(activeKey) {
    setactive(activeKey);
    setSearchParams({ tab: activeKey });
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
  }

  const url = "performance/fetch_performances";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  const tabConfigurations = data?.map((item, index) => ({
    label: (
      <span className="flex items-center">
        <span>{item?.perfName}</span>
      </span>
    ),
    key: String(index + 1),
    children: (
      <ServicePerfList
        perfType={item?.perfType}
        perfId={item?.perfId}
        index={index}
        activeTabKey={active}
        refetchKey={refetchKey}
      />
    ),
  }));

  return (
    <>
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Asal", path: "/scheme/asal-scheme" },
          { title: "Asal View", path: "/scheme/asal-scheme-view" },
          { title: `Performance Indicators ${activeObjSchemes?.schName}` },
        ]}
      />

      <div className="white_card mt-[2.41rem] flex-1 min-h-[80vh]">
        <div className="form-add-h">{iwuaObj?.instName} IWUA</div>
        <Tabs
          items={tabConfigurations}
          defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="mt-[1.75rem] iwua-tab-holder  iwua-tabs-btn iwua-tabs-btn-inactive iwua-ink-bar iwua-nav-list "
        />
      </div>
    </>
  );
}

export default AsalIndicatorsList;
